import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'no-search',
  setup(__props) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/09/21 15:45:03
 * @description: 未筛选到数据
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require('./no-search-data.svg')
  }, null, 8, _hoisted_1))
}
}

})